import React, { useRef, useState } from 'react'
import { Canvas, useFrame } from 'react-three-fiber'

const BuildSquares = () => {
  const squares = []

  for (let i = 0; i < 15; i++) {
    squares.push({
      multi: getRandomArbitrary(0.1, 0.2),
      color: getColor(),
      inivx: Math.floor(Math.random() * 2) === 1 ? 0.1 : -0.1,
      inivy: Math.floor(Math.random() * 2) === 1 ? 0.1 : -0.1,
      size: getRandomArbitrary(0.1, 1),
      position: [getRandomArbitrary(-4, 4), getRandomArbitrary(-4, 4), getRandomArbitrary(-5, 2)]
    })
  }

  return (
    <>
      {squares.map((e, i) => <Box key={i} {...e} />)}
    </>
  )
}

const getColor = () => {
  const i = Math.floor((Math.random() * 2))
  // '#0d0f16',
  // '#1BC8FC',
  const colors = [
    '#0d0f16',
    '#053C78',
  ]
  return colors[i]
}

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

function Box({ multi, size, position, inivx, inivy, color }) {
  const mesh = useRef()
  const [vx, setvx] = useState(inivx * multi)
  const [vy, setvy] = useState(inivy * multi)

  useFrame(() => {
    if (mesh.current.position.x < -7) {
      setvx(0.1 * multi)
    } else if (mesh.current.position.x > 7) {
      setvx(-0.1 * multi)
    }

    if (mesh.current.position.y < -4) {
      setvy(0.1 * multi)
    } else if (mesh.current.position.y > 4) {
      setvy(-0.1 * multi)
    }
    mesh.current.position.x += vx
    mesh.current.position.y += vy
    mesh.current.rotation.x += vx
    mesh.current.rotation.y += vy
    mesh.current.rotation.x = mesh.current.rotation.y += 0.01
  })
  return (
    <mesh
      position={position}
      ref={mesh}
      scale={[size, size, size]}>
      <boxBufferGeometry attach="geometry" args={[1, 1, 1]} />
      <meshStandardMaterial attach="material" color={color} />
    </mesh>
  )
}

export default () => {

  return (
    <div className="h-screen">
      <Canvas>
        <ambientLight />
        <pointLight position={[10, 10, 10]} />
        {BuildSquares()}
      </Canvas>
    </div>
  )
}
